<section class="page">
  <header class="page-header">
    <h2>Attribution</h2>
    <p class="subtitle">Attribuer, consulter et exporter les attributions cartouches/groupes d'amorces.</p>
  </header>

  @if (success) {
    <p class="success">{{ success }}</p>
  }

  @if (error) {
    <p class="error">{{ error }}</p>
  }

  @if (showAssignSection) {
    <form class="panel" (ngSubmit)="submitAttributionsCroisees()">
      <h3>Attribuer des cartouches à des groupes</h3>

      <div class="grid-2">
        <section>
          <h4>Cartouches livrées non attribuées</h4>
          @if (!loadingCartouches) {
            <p class="compteur-ligne">Total disponibles : <strong>{{ cartouchesSansAttribution.length }}</strong></p>
            <p class="compteur-ligne">Sélectionnées : <strong>{{ selectedCartoucheIds.length }}</strong></p>
          }
          @if (loadingCartouches) {
            <p>Chargement des cartouches...</p>
          } @else if (cartouchesSansAttribution.length === 0) {
            <p>Aucune cartouche livrée non attribuée.</p>
          } @else {
            <div class="checkbox-list">
              @for (cartouche of cartouchesSansAttribution; track cartouche.id) {
                <label class="checkbox-item">
                  <input
                    type="checkbox"
                    [checked]="isCartoucheChecked(cartouche.id)"
                    (change)="toggleCartouche(cartouche.id, $any($event.target).checked)"
                  />
                  <span>{{ cartouche.nom }}</span>
                </label>
              }
            </div>
          }
        </section>

        <section>
          <h4>Groupes d'amorces</h4>
          @if (loadingGroupes) {
            <p>Chargement des groupes d'amorces...</p>
          } @else if (groupes.length === 0) {
            <p>Aucun groupe d'amorces disponible.</p>
          } @else {
            <div class="checkbox-list">
              @for (groupe of groupes; track groupe.id) {
                <label class="checkbox-item">
                  <input
                    type="checkbox"
                    [checked]="isGroupeChecked(groupe.id)"
                    (change)="toggleGroupe(groupe.id, $any($event.target).checked)"
                  />
                  <span>{{ groupe.nom }}<span class="codes-amorces" *ngIf="groupe.amorces_codes"> — {{ groupe.amorces_codes }}</span></span>
                </label>
              }
            </div>
          }
        </section>
      </div>

      <button type="submit" [disabled]="saving || selectedCartoucheIds.length === 0 || selectedGroupeIds.length === 0">
        Attribuer (croisé)
      </button>
    </form>
  }

  @if (showViewSection) {
    <section class="panel">
      <h3>Attributions existantes</h3>
      <div class="date-filter-bar">
        <label class="date-filter-label">
          Du
          <input type="date" class="date-filter-input" [(ngModel)]="filterDateFrom" />
        </label>
        <label class="date-filter-label">
          Au
          <input type="date" class="date-filter-input" [(ngModel)]="filterDateTo" />
        </label>
      </div>
      @if (loadingAttributions) {
        <p>Chargement des attributions...</p>
      } @else if (attributions.length === 0) {
        <p>Aucune attribution enregistrée.</p>
      } @else if (filteredAttributions.length === 0) {
        <p>Aucune attribution sur cette période.</p>
      } @else {
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Cartouche</th>
                <th>Groupe d'amorces</th>
                <th>Date d'attribution</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              @for (item of filteredAttributions; track item.cartouche_id + '-' + item.groupe_amorce_id) {
                <tr>
                  <td>{{ item.cartouche_nom }}</td>
                  <td>{{ item.groupe_amorce_nom }}</td>
                  <td>{{ formatDate(item.date_attribution) }}</td>
                  <td>
                    <button type="button" class="btn-danger" (click)="removeAttribution(item)">Supprimer attribution</button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </section>
  }

  @if (showExportSection) {
    <section class="panel">
      <h3>Export Excel</h3>
      <p class="muted">Colonnes exportées: code cartouche, groupe d'amorces, codes des amorces, date d'attribution, commande séquençage effectuée, date commande séquençage.</p>
      <button type="button" [disabled]="exporting" (click)="exportExcel()">Exporter en Excel</button>
    </section>
  }
</section>
